import React, {  useEffect, useRef, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import {
  CircularAvatar,
  ErrorSuccessModal,
  TableHeader,
  TableLoader,
} from "../../commons";
import {
  getTimesheetReportHoursForSpecificJobAction,
  resetReportForSpecificJobList,
  resetReportForSpecificJobTotalCount,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
  resetTotalWorkingHoursOnSpecificJob,
} from "../../../redux/timeSheet";
import UsersWorkingOnSpecificJobTable from "./UsersWorkingOnSpecificJobTable";
import { USER_WORKING_ON_JOBS_HEADERS } from "../../../constant/tableHeadersConstants/usersWorkingOnSpecificJobHeaderConst";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import { CalenderIcon } from "../../Icon";
import { Toaster } from "react-hot-toast";
import { resetSession } from "../../../redux/auth";
import { GetTimeSheetUserWorkOnSpecificJobPayloadType } from "../../../commonTypes/timeSheetTypes";
import {
  getSingleJobsScheduledListAction,
  resetJobScheduledHoursList,
  resetSingleJobScheduledHoursSum,
} from "../../../redux/scheduling";
import { GetScheduledJobsHourPayloadType } from "../../../commonTypes/schedulingTypes";
import { SingleJobsScheduledHoursListType } from "../../../redux/scheduling/schedulingTypes";

type AppProps = {
  modal: boolean;
  token: string | null;
  toggleModal: () => void;
  jobTypeId?: string;
  dispatchGetTimesheetReportHoursForSpecificJobAction: (
    data: GetTimeSheetUserWorkOnSpecificJobPayloadType
  ) => void;
  dispatchGetSingleJobScheduledHoursAction: (
    data: GetScheduledJobsHourPayloadType
  ) => void;
  fetching: boolean;
  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;
  specificUsersJobList: any[];
  specificUsersJobTotalCount: number | string;
  showUsersWorkingOnJobData: any;
  dispatchResetSession: () => void;
  totaltime: string;
  singleJobScheduledHoursSum: number;
  singleJobScheduledHoursList: SingleJobsScheduledHoursListType[] | [];
  singleJobScheduledHoursListCount: number;
  dispatchResetTimeSheetReportSuccess: () => void;
  dispatchResetTimeSheetReportError: () => void;
  dispatchResetTimeSheetReportMessage: () => void;
  dispatchResetTimeSheetReportStatusCode: () => void;
  dispatchResetReportForSpecificJobTotalCount: () => void;
  dispatchResetReportForSpecificJobList: () => void;
  dispatchResetTotalTime: () => void;
  dispatchResetSingleJobScheduledHoursSum: () => void;
  dispatchResetJobScheduledHoursList: () => void;
};
const ShowUsersWorkingOnJobModal = ({
  modal,
  toggleModal,
  dispatchGetTimesheetReportHoursForSpecificJobAction,
  token,
  jobTypeId,
  statusCode,
  success,
  error,
  totaltime,
  fetching,
  dispatchResetSession,
  dispatchResetTimeSheetReportSuccess,
  dispatchResetTimeSheetReportError,
  dispatchResetTimeSheetReportMessage,
  dispatchResetTimeSheetReportStatusCode,
  dispatchResetReportForSpecificJobTotalCount,
  dispatchGetSingleJobScheduledHoursAction,
  dispatchResetReportForSpecificJobList,
  dispatchResetTotalTime,
  specificUsersJobList,
  showUsersWorkingOnJobData,
  singleJobScheduledHoursSum,
  singleJobScheduledHoursList,
  dispatchResetSingleJobScheduledHoursSum,
  dispatchResetJobScheduledHoursList,
}: AppProps) => {
  const [data, setData] = useState<[] | any[]>([]);
  const scrollRef = useRef<any>("");
  const totalHours = totaltime
    ? totaltime?.includes(".")
      ? Number(totaltime).toFixed(2)
      : 0
    : "";

  useEffect(() => {
    dispatchResetTimeSheetReportSuccess();
    dispatchResetTimeSheetReportError();
    dispatchResetTimeSheetReportMessage();
    dispatchResetTimeSheetReportStatusCode();
    dispatchResetReportForSpecificJobTotalCount();
    dispatchResetReportForSpecificJobList();
    dispatchResetTotalTime();
    dispatchResetSingleJobScheduledHoursSum();
    dispatchResetJobScheduledHoursList();
    if (token && jobTypeId) {
      let finalData: any = {
        token,
        job_id: jobTypeId,
      };
      dispatchGetSingleJobScheduledHoursAction(finalData);
      dispatchGetTimesheetReportHoursForSpecificJobAction(finalData);
    }
  }, []);

  const openJobStatusStyle = () => {
    return {
      padding: "4px 14px",
      color: "#82b01f",
      background: "#e7f0d4",
      borderRadius: "16px",
      fontSize: "12px",
      fontWeight: "400",
    };
  };
  const closeJobStatusStyle = () => {
    return {
      padding: "4px 14px",
      color: "#6f7a90",
      background: "#f4f6f8",
      borderRadius: "16px",
      fontSize: "12px",
      fontWeight: "400",
    };
  };

  useEffect(() => {
    let newData: any[] = [];
    let newSingleJobScheduledHoursList = singleJobScheduledHoursList?.length
      ? JSON.parse(JSON.stringify(singleJobScheduledHoursList))
      : [];

    if (
      specificUsersJobList?.length > 0 &&
      !newSingleJobScheduledHoursList?.length
    ) {
      newData = specificUsersJobList;
    } else if (
      singleJobScheduledHoursList?.length > 0 &&
      !specificUsersJobList?.length
    ) {
      newData = singleJobScheduledHoursList;
    } else if (
      singleJobScheduledHoursList?.length > 0 &&
      newSingleJobScheduledHoursList?.length > 0
    ) {
      let p1 = 0;
      let p2 = 0;
      while (p1 < specificUsersJobList?.length) {
        if (
          specificUsersJobList[p1]?.user_id ==
          newSingleJobScheduledHoursList[p2]?.user_id
        ) {
          newData.push({
            ...specificUsersJobList[p1],
            total_hours: newSingleJobScheduledHoursList[p2]?.total_hours,
          });
          newSingleJobScheduledHoursList?.splice(p2, 1);
          p1++;
          p2 = 0;
        } else if (p2 > newSingleJobScheduledHoursList?.length - 1) {
          newData.push({ ...specificUsersJobList[p1] });
          p1++;
          p2 = 0;
        } else {
          p2++;
        }
      }
      for (let i = 0; i < newSingleJobScheduledHoursList?.length; i++) {
        newData.push(newSingleJobScheduledHoursList[i]);
      }
    }
    setData([...newData]);
  }, [specificUsersJobList, singleJobScheduledHoursList]);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetReportError();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <div>
      <Modal
        centered
        isOpen={modal}
        toggle={toggleModal}
        size="xl"
        backdrop="static"
        // keyboard={false}
      >
        <ModalHeader className="p-3" id="cross-cut" toggle={toggleModal}>
          List of users working on this job
        </ModalHeader>
        <ModalBody className="pl-4 pr-4" style={{ paddingLeft: "40px" }}>
          <>
            <div
              ref={scrollRef}
              className="pl-1"
              style={{ height: "400px", overflowY: "scroll" }}
            >
              {fetching ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : (
                <>
                  <div className="d-flex col-md-12 mb-3">
                    {data?.length > 0 ? (
                      <div className="row col-md-7">
                        <div style={{ minWidth: "95%" }}>
                          <div className="table-bordered">
                            <table className="table">
                              <thead
                                className="text-left sticky-table-header"
                                style={{
                                  backgroundColor: "#f4f6f8",
                                  color: "#464f60",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}
                              >
                                <tr
                                  style={{
                                    color: "#464f60",
                                    backgroundColor: "#e8ecf0",
                                  }}
                                >
                                  <td>
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        color: "#464f60",
                                      }}
                                    >
                                      TOTAL
                                    </span>
                                  </td>
                                  <td></td>

                                  <td
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      color: "#464f60",
                                    }}
                                  >
                                    {totalHours ? totalHours : 0}
                                  </td>
                                  <td
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      color: "#464f60",
                                    }}
                                  >
                                    {singleJobScheduledHoursSum
                                      ? singleJobScheduledHoursSum
                                          ?.toString()
                                          ?.includes(".")
                                        ? +singleJobScheduledHoursSum?.toFixed(
                                            2
                                          )
                                        : singleJobScheduledHoursSum
                                      : 0}
                                  </td>
                                </tr>
                                <TableHeader
                                  tableHeader={USER_WORKING_ON_JOBS_HEADERS}
                                />
                              </thead>
                              <tbody>
                                <UsersWorkingOnSpecificJobTable
                                  // data={specificUsersJobList}
                                  data={data}
                                  tableHeaders={USER_WORKING_ON_JOBS_HEADERS}
                                />
                                {fetching && <div>{<InfiniteLoader />}</div>}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        className="row col-md-7"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "100%",
                          fontSize: "22px",
                          margin: "auto",
                        }}
                      >
                        <div>
                          <p
                            style={{
                              fontSize: "18px",
                              color: "#262a44",
                              marginBottom: "2px",
                            }}
                          >
                            No users assigned to this job
                          </p>
                          <div
                            style={{
                              alignItems: "center",
                              fontSize: "13px",
                              color: "#262a44",
                              textAlign: "center",
                            }}
                          >
                            <p className="mb-0">
                              Please contact this job manager to assign{" "}
                            </p>
                            <p className="mb-0">users for this job</p>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* </ContentArea> */}
                    <div className="col-md-5 mb-3">
                      <div
                        className="mt-2 p-0"
                        style={{
                          cursor: "pointer",
                          border: "1px solid #bfcbe1",
                          borderRadius: "8px",
                        }}
                      >
                        <div className="list-header pl-3 pt-3">
                          Jobs Summary
                        </div>
                        <hr style={{ borderColor: "#bfcbe1" }} />

                        <div
                          className="inside-card-header d-flex w-100 pt-2 pl-3"
                          style={{ alignItems: "center" }}
                        >
                          <span
                            style={{
                              color: "#6e7491",
                              fontSize: "13px",
                              fontWeight: "500",
                              width: "50%",
                            }}
                          >
                            Currently Responsible
                          </span>
                          {showUsersWorkingOnJobData?.currently_responsible ? (
                            <div
                              className="d-flex "
                              style={{ width: "50%", alignItems: "center" }}
                            >
                              <CircularAvatar
                                name={`${showUsersWorkingOnJobData?.currently_responsible} `}
                                image={
                                  showUsersWorkingOnJobData?.profile_pic &&
                                  showUsersWorkingOnJobData?.profile_pic
                                    ?.file_url
                                }
                              />
                              <span
                                style={{
                                  paddingLeft: "5px",
                                  fontSize: "16px",
                                  color: "#262a44",
                                  fontWeight: "400",
                                }}
                              >
                                {
                                  showUsersWorkingOnJobData?.currently_responsible
                                }
                              </span>
                            </div>
                          ) : (
                            <span
                              style={{
                                width: "50%",
                                fontSize: "14px",
                                color: "#262a44",
                                fontWeight: "400",
                              }}
                            >
                              --/--
                            </span>
                          )}
                        </div>

                        <div className="inside-card-header d-flex w-100 pt-4 pl-3">
                          <span
                            style={{
                              color: "#6e7491",
                              fontSize: "13px",
                              fontWeight: "500",
                              width: "50%",
                            }}
                          >
                            Job Type & ID
                          </span>
                          <span
                            style={{
                              width: "50%",
                              fontSize: "14px",
                              color: "#262a44",
                              fontWeight: "400",
                              paddingRight: "5px",
                              wordWrap: "break-word",
                            }}
                          >{`${showUsersWorkingOnJobData?.job_id}_${showUsersWorkingOnJobData?.job_type}`}</span>
                        </div>
                        <div className="inside-card-header d-flex w-100 pt-4 pl-3">
                          <span
                            style={{
                              color: "#6e7491",
                              fontSize: "13px",
                              fontWeight: "500",
                              width: "50%",
                            }}
                          >
                            Target End Date
                          </span>
                          {showUsersWorkingOnJobData?.target_end_date ? (
                            <div style={{ width: "50%", alignItems: "center" }}>
                              <span
                                className="calender-icon"
                                style={{
                                  right: "12px",
                                  top: "35px",
                                  cursor: "pointer",
                                }}
                              >
                                {" "}
                                <CalenderIcon />
                              </span>
                              <span
                                style={{
                                  width: "50%",
                                  fontSize: "14px",
                                  paddingLeft: "3px",
                                  color: "#262a44",
                                  fontWeight: "400",
                                }}
                              >
                                {" "}
                                {showUsersWorkingOnJobData?.target_end_date}
                              </span>
                            </div>
                          ) : (
                            <span
                              style={{
                                width: "50%",
                                fontSize: "14px",
                                color: "#262a44",
                                fontWeight: "400",
                              }}
                            >
                              --/--
                            </span>
                          )}
                        </div>
                        <div className="inside-card-header d-flex w-100 pt-4 pl-3">
                          <span
                            style={{
                              color: "#6e7491",
                              fontSize: "13px",
                              fontWeight: "500",
                              width: "50%",
                            }}
                          >
                            Status
                          </span>
                          <span
                            style={
                              showUsersWorkingOnJobData?.job_status === "Open"
                                ? openJobStatusStyle()
                                : closeJobStatusStyle()
                            }
                          >
                            {showUsersWorkingOnJobData?.job_status}
                          </span>
                        </div>
                        <div className="inside-card-header d-flex w-100 pt-4 pl-3 pb-3">
                          <span
                            style={{
                              color: "#6e7491",
                              fontSize: "13px",
                              fontWeight: "500",
                              width: "50%",
                            }}
                          >
                            Job Summary
                          </span>
                          <span
                            style={{
                              width: "50%",
                              fontSize: "14px",
                              lineHeight: "23px",
                              color: "#262a44",
                              fontWeight: "400",
                              paddingRight: "8px",
                              wordWrap: "break-word",
                            }}
                          >
                            {showUsersWorkingOnJobData?.job_description}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <></>
                </>
              )}
            </div>
          </>
        </ModalBody>
      </Modal>
      <Toaster />

      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.timeSheet.fetching,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  totaltime: state.timeSheet.totalWorkingHoursOnSpecificJob,
  specificUsersJobList: state.timeSheet.reportForSpecificJobList,
  specificUsersJobTotalCount: state.timeSheet.reportForSpecificJobTotalCount,
  singleJobScheduledHoursSum: state.scheduling.singleJobScheduledHoursSum,
  singleJobScheduledHoursList: state.scheduling.singleJobScheduledHoursList,
  singleJobScheduledHoursListCount:
    state.scheduling.singleJobScheduledHoursListCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetReportSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetReportError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetReportMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetSingleJobScheduledHoursSum: () =>
    dispatch(resetSingleJobScheduledHoursSum()),
  dispatchResetJobScheduledHoursList: () =>
    dispatch(resetJobScheduledHoursList()),
  dispatchResetTimeSheetReportStatusCode: () =>
    dispatch(resetTimeSheetStatusCode()),
  dispatchGetTimesheetReportHoursForSpecificJobAction: (
    data: GetTimeSheetUserWorkOnSpecificJobPayloadType
  ) => dispatch(getTimesheetReportHoursForSpecificJobAction(data)),
  dispatchGetSingleJobScheduledHoursAction: (
    data: GetScheduledJobsHourPayloadType
  ) => dispatch(getSingleJobsScheduledListAction(data)),
  dispatchResetReportForSpecificJobTotalCount: () =>
    dispatch(resetReportForSpecificJobTotalCount()),
  dispatchResetReportForSpecificJobList: () =>
    dispatch(resetReportForSpecificJobList()),
  dispatchResetTotalTime: () => dispatch(resetTotalWorkingHoursOnSpecificJob()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowUsersWorkingOnJobModal);
